import { Component, inject, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute, ParamMap } from '@angular/router'
import Order from '@client/Order'
import { switchMap } from 'rxjs/operators'
import { OrdersService } from '@client/Services/OrdersService'
import HttpError from '@ui/HttpError'
import { MatStep, MatStepLabel, MatStepper } from '@angular/material/stepper'
import { NgStyle } from '@angular/common'
import { CreateMandateComponent } from '@client/Components/Orders/Order/PaymentPlans/Gocardless/CreateMandate.Component'
import { ToastrService } from 'ngx-toastr'
import { CreatePaymentPlanComponent } from '@client/Components/Orders/Order/PaymentPlans/Gocardless/CreatePaymentPlan.Component'
import { PaymentPlanConfirmationComponent } from '@client/Components/Orders/Order/PaymentPlans/Gocardless/PaymentPlanConfirmation.Component'
import { PaymentPlan } from '@client/PaymentPlan'

@Component({
	selector: 'setup-gocardless-order-payment-plan',
	templateUrl: './SetupOrderPaymentPlan.Component.html',
	imports: [
		MatStepper,
		NgStyle,
		MatStep,
		MatStepLabel,
		CreateMandateComponent,
		CreatePaymentPlanComponent,
		PaymentPlanConfirmationComponent,
	],
})
export class SetupOrderPaymentPlanComponent implements OnInit {
	@ViewChild('stepper') private readonly stepper: MatStepper

	protected step: number = 0

	protected order: Order

	protected paymentPlan: PaymentPlan

	private readonly route: ActivatedRoute

	private readonly ordersService: OrdersService

	private readonly toastrService: ToastrService

	constructor() {
		this.route = inject(ActivatedRoute)
		this.ordersService = inject(OrdersService)
		this.toastrService = inject(ToastrService)
	}

	public ngOnInit() {
		this.route.paramMap
			.pipe(
				switchMap(async (params: ParamMap) => {
					try {
						const step = params.get('step')

						if (step === '1') {
							this.step = 0
						} else if (step === '2') {
							this.step = 1
						} else if (step === 'failed') {
							this.step = 0

							this.toastrService.error(
								'Failed to handle your request. Please try again.',
								'Error',
							)
						}

						return this.ordersService.findById(parseInt(params.get('id'), 10))
					} catch (error) {
						if (!(error instanceof HttpError)) {
							throw error
						}
					}
				}),
			)
			.subscribe((order: Order) => {
				if (order) {
					this.order = order
				}
			})
	}

	protected readonly showStepThree = (paymentPlan: PaymentPlan) => {
		this.paymentPlan = paymentPlan
		this.stepper.steps.get(0).completed = true
		this.stepper.steps.get(0).interacted = true
		this.stepper.steps.get(1).completed = true
		this.step = 2
		this.stepper.next()
	}
}
